import Questions from '@/components/questions/Questions'
import QuestionList from '@/components/questions/QuestionList'
import AddQuestion from '@/components/questions/AddQuestion'
import ManageQuestion from '@/components/questions/ManageQuestion'

export default [
  {
    path: '/questions',
    component: Questions,
    children: [
      {path: '', component: QuestionList},
      {path: 'add', component: AddQuestion},
      {path: ':id', component: ManageQuestion}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/questions/routes.js